// extracted by mini-css-extract-plugin
export default {"containerSidebar":"styles_containerSidebar__e89cu","icons":"styles_icons__vVt89"};